'use strict';

module.exports = {
  ShortcutManager: require('./shortcut-manager'),
  Shortcuts: require('./component/')
};